import { createFileRoute } from '@tanstack/react-router'

import { OutboundWebhooksSettingsPage } from '@/features/integrations/outbound-webhooks-settings-page'

export const Route = createFileRoute('/_app/integracoes/webhooks-saida')({
  component: OutboundWebhooksSettingsPage,
})
